module.exports = __webpack_public_path__ + "static/media/dentaqua.396efe5b.jpg";